export const onIdle = (fn: () => void): void => {
  if ("scheduler" in globalThis) {
    // @ts-expect-error scheduler is not typed
    globalThis.scheduler.postTask(fn, { priority: "background" });
    return;
  } else if ("requestIdleCallback" in globalThis) {
    globalThis.requestIdleCallback(fn);
  } else {
    setTimeout(fn, 1);
  }
};
